export default "__VITE_ASSET__YMyr856Z__"